module.exports = __webpack_public_path__ + "static/img/step1_img.7a17b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/TW/img/step1_img.png
// module id = eC13
// module chunks = 1